// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"9c71d31b","429":"03e2771b","495":"ca9be09e","745":"623afe3a"}[chunkId] + ".chunk.css";
};